import { render, staticRenderFns } from "./UserBadge.vue?vue&type=template&id=231694c8&"
import script from "./UserBadge.vue?vue&type=script&lang=js&"
export * from "./UserBadge.vue?vue&type=script&lang=js&"
import style0 from "./UserBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports